import { render, staticRenderFns } from "./Benefit.vue?vue&type=template&id=78c296d9&scoped=true"
import script from "./Benefit.vue?vue&type=script&lang=js"
export * from "./Benefit.vue?vue&type=script&lang=js"
import style0 from "./Benefit.vue?vue&type=style&index=0&id=78c296d9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c296d9",
  null
  
)

export default component.exports